var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{ref:"block"},[_vm._t("default",null,{"show":_vm.show})],2)}
var staticRenderFns = []

export { render, staticRenderFns }